module.exports = __webpack_public_path__ + "static/media/logistics-banner.c4de7d99.jpg";